"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _styledSystem = require("styled-system");

var _excluded = ["title", "regions", "onClick", "colorMode"];

var _templateObject;

var getColor = function getColor(props) {
  return (props === null || props === void 0 ? void 0 : props.colorMode) === 'light' ? 'colors.white' : 'colors.greys.charcoal';
};

var StyledLink = (0, _styledBase["default"])(_.Link)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (props) {
  return (0, _styledSystem.themeGet)(getColor(props));
});

var RegionLinks = function RegionLinks(_ref) {
  var title = _ref.title,
      regions = _ref.regions,
      _onClick = _ref.onClick,
      colorMode = _ref.colorMode,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_.Flex, {
    mb: 8,
    flexDirection: "column",
    width: ['50%', '25%']
  }, /*#__PURE__*/_react["default"].createElement(_.Heading.h3, (0, _extends2["default"])({
    mb: 4,
    fontSize: "base",
    color: colorMode === 'light' ? 'white' : 'greys.charcoal',
    "data-testid": title ? 'region-links-header' : undefined,
    "aria-hidden": !title
  }, rest), title !== null && title !== void 0 ? title : /*#__PURE__*/_react["default"].createElement("span", null, "\u200B")), regions.map(function (region, index) {
    return /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({
      key: "footer-link-".concat(index),
      onClick: function onClick() {
        return _onClick(region);
      },
      lineHeight: "1.5",
      fontSize: "sm",
      pr: 4,
      color: colorMode === 'light' ? 'white' : 'greys.charcoal',
      colorMode: colorMode
    }, region), region.name);
  }));
};

RegionLinks.propTypes = {
  title: _propTypes["default"].string,
  regions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    href: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  onClick: _propTypes["default"].func,
  colorMode: _propTypes["default"].oneOf(['light', 'dark'])
};
RegionLinks.defaultProps = {
  title: undefined,
  regions: [],
  onClick: function onClick() {},
  colorMode: 'light'
};
var _default = RegionLinks;
exports["default"] = _default;